import { SvgIcon, createSvgIcon } from "@mui/material";

const NoteEighthIcon = createSvgIcon(
  <SvgIcon viewBox="0 0 14.85 25.74">
    <path d="M14,7.83a14.07,14.07,0,0,0-2.59-3C10.12,3.43,8.38,1.93,8,0h-1V19.34a4.5,4.5,0,0,0-4.56.57c-2,1.32-2.92,3.47-2,4.81s3.22,1.35,5.23,0A4.68,4.68,0,0,0,7.93,21h0V4.93a17.26,17.26,0,0,1,2.62,1.46c1.55,1.07,3.13,2.47,3.51,4.41a7.15,7.15,0,0,1-2,5.82c-.33.32-1,.92-.81,1.05s.95-.58,1.25-1a8.09,8.09,0,0,0,2.38-5.63A6.74,6.74,0,0,0,14,7.83Z"/>
  </SvgIcon>
);

export default NoteEighthIcon;